/**
 * Maps fgfunctions Licman `deployShop` HTTP status and English `error` text to user-facing German copy.
 *
 * @param {unknown} err - Thrown from `deployShop` thunk (`status`, `message` from API `error`)
 * @returns {string}
 */
export function getLicmanShopDeployAlertMessage(err) {
    const status = err && typeof err === "object" ? err.status : undefined;
    const raw = err && typeof err === "object" && typeof err.message === "string" ? err.message : "";
    const message = raw.toLowerCase();

    if (status === 401) {
        return "Sitzung abgelaufen. Bitte neu anmelden.";
    }
    if (status === 403) {
        return "Für diese Lizenz ist kein aktives, bezahltes Onlineshop-Modul gebucht. Bitte Modul buchen oder zuweisen und danach erneut versuchen.";
    }
    if (status === 404) {
        return "Shop-Eintrag wurde nicht gefunden.";
    }
    if (status === 503) {
        return "Mandanten-Datenbank ist nicht erreichbar (nur PostgreSQL-Mandanten oder Client noch nicht initialisiert).";
    }
    if (status === 500) {
        return "Fehler beim Ausführen der Aktion. Bitte später erneut versuchen oder den Support informieren.";
    }
    if (status === 400) {
        if (message.includes("invalid licman header")) {
            return "Ungültige Licman-Umgebung. Bitte Seite neu laden oder Support informieren.";
        }
        if (message.includes("only fgwebshop")) {
            return "Diese Aktion ist nur für den FG-Webshop (fgwebshop) verfügbar.";
        }
        if (message.includes("deployfrontendurl")) {
            return "Für diese Lizenz fehlt die Deploy-Frontend-URL; Mandant kann nicht ermittelt werden.";
        }
        if (message.includes("invalid request body")) {
            return "Ungültige Anfrage. Bitte Eingaben prüfen oder Seite neu laden.";
        }
        return "Ungültige Anfrage. Bitte Eingaben prüfen oder Seite neu laden.";
    }
    if (typeof status === "number") {
        return `Fehler beim Ausführen der Aktion (HTTP ${status}).`;
    }
    return "Fehler beim Ausführen der Aktion.";
}
